export enum DatasheetCheckboxFieldValue {
  checked = "Y",
  unchecked = "N",
}
